// store/slices/bannerSlice.ts

import { MatchItem } from '@/types/events';
import { BannerGroup } from '@/types/home';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { bannerApi } from '../api/bannerApi';

interface BannerState {
  featuredMatches: MatchItem[];
  banners: BannerGroup;
  count: number;
}

const initialState: BannerState = {
  featuredMatches: [],
  banners: {},
  count: 0,
};

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    setFeaturedMatches: (state, action: PayloadAction<MatchItem[]>) => {
      state.featuredMatches = action.payload;
    },

    clearFeaturedMatches: (state) => {
      state.featuredMatches = [];
    },

    clearBanners: (state) => {
      state.banners = {};
      state.count = 0;
    },

    clearAllBannerData: (state) => {
      state.featuredMatches = [];
      state.banners = {};
      state.count = 0;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(bannerApi.endpoints.getBanners.matchFulfilled, (state, { payload }) => {
      state.banners = payload.data || {};
      state.count = payload.count || 0;
    });
  },
});

export const { setFeaturedMatches, clearFeaturedMatches, clearBanners, clearAllBannerData } =
  bannerSlice.actions;

export default bannerSlice.reducer;
